import { Button } from 'primereact/button';
import { useState, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Toast, ToastMessage } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import { InputTextarea } from 'primereact/inputtextarea';
import TypeService from "../../services/complaintType/type";

interface ComplaintType {
  complaintName: string;
  description: string;
}

const TypeSearch: React.FC<{onSearch: (keyword:string) => void}> = ({ onSearch }) => {
  const { t } = useTranslation();
  const [selectedKeyword, setSelectedKeyword] = useState<string>('');
  const [showAddComplaintModal, setShowAddComplaintModal] = useState(false);
  const [name, setName] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const [complaintTypes, setComplaintTypes] = useState<ComplaintType[]>([]);
  const [filteredComplaintTypes, setFilteredComplaintTypes] = useState<ComplaintType[]>([]);
  const toast = useRef<Toast>(null);
  const [nameError, validateError] = useState<string>('');
  const [types, setTypes] = useState<ComplaintType[]>([]);

  const showMessage = (label: string, message: string, severity: ToastMessage['severity']) => {
    toast.current?.show({
      severity: severity,
      summary: label,
      detail: message,
      life: 3000,
    });
  };

  const handleSearch = () => {
    onSearch(selectedKeyword); // Just send keyword to parent
  };
 
  
  
  // const handleSearch = () => {
  //   const keyword = selectedKeyword.toLowerCase().trim();
  //   const filtered = complaintTypes.filter(type =>
  //     type.complaintName.toLowerCase().includes(keyword)
  //   );
  //   setFilteredComplaintTypes(filtered);
  // };
  
  const resetSearchFields = () => {
    setSelectedKeyword('');
    onSearch(''); 
  };

  const handleOnSuccess = async () => {
    const newComplaint: ComplaintType = {
      complaintName: name,
      description: description,
    };

    if (!name.trim()) {
      validateError('Name is required.');
      return;
    }
    const newType = {
      complaintName: name,
      Description: description,
    };

    try {
      const response = await TypeService.addType(newType);
      if(response.isSuccess){
        showMessage('Add Type', 'Type added successfully', 'success');
        window.location.reload();
        setShowAddComplaintModal(false);
        setName('');
        setDescription('');
        } else {
      
        if (response.message === "Complaint type with this name already exists.") {
          showMessage('Duplicate Entry', response.message, 'warn');
        } else {
        
          showMessage('Add Type', 'Failed to add type.', 'error');
        }
      }
    } catch (error) {
      console.error("Error fetching types:", error);
    }
  };

  const handleCloseModal = () => {
    setShowAddComplaintModal(false);
    setName('');
    setDescription('');
    validateError('');
  };

  return (
    <div className="col-12">
      <div className="card border-noround p-2" style={{ minHeight: '3.5rem' }}>
        <div className="input-container font-bold text-white border-round" style={{ float: 'left', width: '18%' }}>
          <div className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              type="search"
              value={selectedKeyword}
              onChange={(e) => setSelectedKeyword(e.target.value)}
              placeholder="Keyword Search"
              style={{ width: '100%' }}
            />
          </div>
        </div>
        <div className="buttons-container">
          <div className="filter-button font-bold text-white border-round" style={{ float: 'left', width: '10%' }}>
            <Button
              className="text-black border-round"
              style={{ width: '100%', textAlign: 'center' }}
              onClick={handleSearch}
              severity="success"
            >
              Filter
            </Button>
          </div>
          <div className="filter-button font-bold text-white border-round ml-2" style={{ float: 'left', width: '10%' }}>
            <Button
              className="text-black border-round"
              style={{ width: '100%', textAlign: 'center' }}
              onClick={resetSearchFields}
              severity="secondary"
              text
              raised
            >
              Reset
            </Button>
          </div>
          <div className="add-button-container border-round font-bold ml-3 text-primary" style={{ textAlign: 'right' }}>
            <Button
              className="bg-blue-700 border-round p-button p-button-text p-component text-center text-white"
              style={{ textAlign: 'center' }}
              onClick={() => setShowAddComplaintModal(true)}
              severity="secondary"
              text
              raised
            >
              Add Complaint Type
            </Button>
          </div>
        </div>
        <Dialog
          visible={showAddComplaintModal}
          className="quickview w-50"
          breakpoints={{ '960px': '75vw', '641px': '90vw' }}
          modal
          onHide={handleCloseModal}
        >
          <h5 className="border-round mb-3 order-top-color p-2 panel-header-text text-center">ADD COMPLAINT TYPE</h5>

          <div className="flex flex-wrap">
            <div className="w-full mb-3 px-3">
              <div className="field">
                <label htmlFor="name" className="label-semi-bold">
                  Type<span className="required">*</span>
                </label>
                <InputText
                  type="text"
                  id="ComplaintName"
                  name="ComplaintName"
                  placeholder="Name"
                  style={{ width: '100%' }}
                  value={name}
                  onChange={(e) => {
                  setName(e.target.value);
                  if (e.target.value.trim()) {
                    validateError('');  
                  }
                }}
                />
                {nameError && <small className="p-error">{nameError}</small>}
              </div>
            </div>
            <div className="w-full mb-3 px-3">
              <div className="field">
                <label htmlFor="usage" className="label-semi-bold">
                  Description
                </label>
                <InputTextarea
                  autoResize
                  id="description"
                  name="description"
                  placeholder="Description"
                  rows={4}
                  cols={30}
                  style={{ width: '100%' }}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="text-right mt-4">
            <Button className="bg-green-700 text-white p-button p-button-text p-component" onClick={handleOnSuccess}>
              Save
            </Button>
          </div>
        </Dialog>
        <Toast ref={toast} />
      </div>
    </div>
  );
};

export default TypeSearch;

